import React, { useCallback, useEffect, useState } from "react";
import Page from "../../types/Page";
import Layout from "../../components/Layout";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import PageHeader from "../../components/PageHeader";
import CabinCard from "../../components/CabinCard";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectInputErrors } from "../../features/errors/errorsSlice";
import { useAuthUser } from "../../features/auth/authHooks";
import {
  AccommodationListItem,
  AccommodationQueryFilters,
  getAccommodationsAsync,
  selectAccommodationItems,
  selectAccommodationsLoadingStatus,
} from "./accommodationsSlice";
import { LOADING_STATUS } from "../../common/constants";
import {
  InitialAllAccommodationsPaginationParameters,
  InitialPaginationParameters,
} from "../../types/pagination.types";
import { selectOwnerInfo } from "../UserPage/userSlice";

const AccommodationsPageType: Page = {
  ActiveTab: "Accommodations",
  DisplayName: "Kohteet",
  DisplayParentName: "Kohteet",
  LinkUrl: "/accommodations",
  Path: "/accommodations",
  RouteName: "accommodations",
};

const AccommodationsPage = () => {
  const inputErrors = useAppSelector(selectInputErrors);
  const accommodations = useAppSelector(selectAccommodationItems);
  const [submitted, setSubmitted] = useState(false);
  const accommodationsLoadingStatus = useAppSelector(
    selectAccommodationsLoadingStatus,
  );
  const dispatch = useAppDispatch();
  const { ownerAccountId } = useAuthUser();
  const [filtering, setFiltering] = useState<AccommodationQueryFilters>({
    PageNumber: InitialAllAccommodationsPaginationParameters.PageNumber,
    PageSize: InitialAllAccommodationsPaginationParameters.PageSize,
    filterCriteria: {
      showDeleted: false,
      searchString: undefined,
      accommodationNumber: undefined,
      novelty: undefined,
      showInWebShop: undefined,
      showInOwnerPage: undefined,
      accommodationGroupId: undefined,
      accountId: ownerAccountId,
    },
  });
  const initFetch = useCallback(() => {
    dispatch(getAccommodationsAsync(filtering));
  }, [dispatch, ownerAccountId]);
  useEffect(() => {
    initFetch();
  }, [initFetch, ownerAccountId]);
  const renderAccommodations = (accommodations: AccommodationListItem[]) => {
    return accommodations
      .slice() // optional: clone array if you don't want to mutate original
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((accommodation) => renderAccommodation(accommodation));
  };

  const renderAccommodation = (accommodation) => {
    let location = "";
    if (
      accommodation.municipality != null &&
      accommodation.municipality.length > 0
    ) {
      location = accommodation.municipality;
    }
    if (accommodation.region != null && accommodation.region.length > 0) {
      location += ", " + accommodation.region;
    }
    if (accommodation.skiResort != null && accommodation.skiResort.length > 0) {
      location += ", " + accommodation.skiResort;
    }
    let description =
      accommodation.beds + " + " + accommodation.extraBeds + " henkilöä";
    let badgeText = "";
    let badgeBg = "";
    if (accommodation.novelty == 1) {
      badgeText = "Uutuus";
      badgeBg = "success";
    }
    if (accommodation.showInWebShop == 2) {
      badgeText = "Offline";
      badgeBg = "danger";
    }
    return (
      <Col key={accommodation.id}>
        <CabinCard
          Url={"/accommodations/modify/" + accommodation.id}
          ImgSrc={accommodation.imageCarouselUrl}
          Title={accommodation.accommodationNumber + ", " + accommodation.name}
          Location={location}
          Desc={description}
          BadgeBg={badgeBg}
          BadgeText={badgeText}
        />
      </Col>
    );
  };
  return (
    <div className={AccommodationsPageType.RouteName}>
      <Layout CurrentPage={AccommodationsPageType}>
        <PageHeader
          Title={AccommodationsPageType.DisplayName}
          SubTitle={AccommodationsPageType.DisplayParentName}
          Back={false}
          Icon="gear"
        />
        {accommodationsLoadingStatus != LOADING_STATUS.IDLE && (
          <>
            <div className="d-flex gap-16 align-items-center">
              <Spinner animation="border" />
              <span>Ladataan kohteita...</span>
            </div>
          </>
        )}
        <Row xs={1} sm={2} md={3} xl={4} className="g-24">
          <>{renderAccommodations(accommodations)}</>
        </Row>
      </Layout>
    </div>
  );
};

export default AccommodationsPage;
